import React from 'react';
import { Check, Star, Shield, Zap } from 'lucide-react';
import { trackAndRedirect } from '../utils/facebook-pixel';
export function PricingTable() {
  const handleEsencialClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAndRedirect('https://pay.hotmart.com/C105102234Y?checkoutMode=10', 'checkout_3', ['producto_3'], 6.39);
  };
  const handleAudioClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAndRedirect('https://pay.hotmart.com/N105102509N?checkoutMode=10', 'checkout_2', ['producto_2'], 14.99);
  };
  const handleSoberaniaClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAndRedirect('https://pay.hotmart.com/N105102600E?checkoutMode=10', 'checkout_1', ['producto_1'], 19.99);
  };
  return <section id="pricing" className="py-8 px-4 bg-[#0a0c0e] border-t border-card-border relative" data-id="element-230">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-cyan-neon/5 rounded-full blur-[150px] pointer-events-none" data-id="element-231"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-232">
        <div className="text-center mb-16" data-id="element-233">
          <h2 className="font-bebas text-4xl md:text-6xl text-white mb-4" data-id="element-234">
            LA ESCALERA DE <span className="text-cyan-neon" data-id="element-235">SOBERANÍA</span>
          </h2>
          <p className="font-inter text-lg max-w-2xl mx-auto font-[700] text-[#FAFBFE]" data-id="element-236">
            Elige tu nivel de blindaje
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-end max-w-6xl mx-auto" data-id="element-237">
          {/* Tier 1: Esencial */}
          <div className="bg-card-dark border border-cyan-neon rounded-2xl p-8 flex flex-col h-full relative glow-cyan" data-id="element-238">
            <div className="mb-8" data-id="element-239">
              <h3 className="font-bebas tracking-wide mb-2 text-[32px] text-[#00F2FF]" data-id="element-240">
                BLINDAJE ESENCIAL
              </h3>
              <div className="flex items-baseline gap-3" data-id="element-241">
                <span className="font-bebas text-white text-[64px] leading-none" data-id="element-242">
                  $6.39
                </span>
                <span className="text-text-muted font-inter text-sm" data-id="element-243">USD</span>
              </div>
              <div className="flex items-center gap-3 mt-3" data-id="element-244">
                <span className="font-inter text-sm text-text-muted line-through decoration-alert-red decoration-2" data-id="element-245">
                  $47 USD
                </span>
                <span className="bg-alert-red/20 text-alert-red font-inter text-xs font-bold px-3 py-1 rounded-full border border-alert-red/30 uppercase tracking-wider" data-id="element-246">
                  -86% OFF
                </span>
              </div>
              <div className="mt-4 flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-lg px-4 py-2" data-id="element-247">
                <span className="text-lg" data-id="element-248">⏰</span>
                <span className="font-inter text-sm text-amber-400 font-semibold" data-id="element-249">
                  Oferta por tiempo limitado
                </span>
              </div>
              <p className="text-sm text-text-muted mt-5 font-inter leading-relaxed" data-id="element-250">
                El sistema táctico completo para desmantelar el hábito en las
                próximas <strong className="text-white" data-id="element-251">24-72 horas</strong>.
              </p>
            </div>

            <div className="space-y-3 mb-8" data-id="element-252">
              <div className="flex items-start gap-3 bg-cyan-neon/5 border border-cyan-neon/10 rounded-xl px-4 py-3 transition-colors hover:border-cyan-neon/25" data-id="element-253">
                <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-254" />
                <span className="font-inter text-sm text-gray-200" data-id="element-255">
                  Primera victoria en menos de{' '}
                  <strong className="text-white" data-id="element-256">24 horas</strong>
                </span>
              </div>
              <div className="flex items-start gap-3 bg-cyan-neon/5 border border-cyan-neon/10 rounded-xl px-4 py-3 transition-colors hover:border-cyan-neon/25" data-id="element-257">
                <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-258" />
                <span className="font-inter text-sm text-gray-200" data-id="element-259">
                  Reducción del <strong className="text-white" data-id="element-260">80%</strong> en
                  impulsos en 7 días
                </span>
              </div>
              <div className="flex items-start gap-3 bg-cyan-neon/5 border border-cyan-neon/10 rounded-xl px-4 py-3 transition-colors hover:border-cyan-neon/25" data-id="element-261">
                <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-262" />
                <span className="font-inter text-sm text-gray-200" data-id="element-263">
                  Coherencia total en{' '}
                  <strong className="text-white" data-id="element-264">30 días</strong>
                </span>
              </div>
            </div>

            <div className="mb-8" data-id="element-265">
              <img src="https://cdn.magicpatterns.com/uploads/dyiAZ8efPd1VmJdWYsFdKZ/MOCKUP_PRINCIPAL_CON_SUS_BONUS.png" alt="Protocolo de Blindaje con sus 3 Bonus" className="w-full h-auto rounded-lg" data-id="element-266" />
            </div>
            <div className="space-y-3 mb-8" data-id="element-267">
              <div className="flex items-start gap-3 bg-cyan-neon/5 border border-cyan-neon/10 rounded-xl px-4 py-3 transition-colors hover:border-cyan-neon/25" data-id="element-268">
                <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-269" />
                <span className="font-inter text-sm text-gray-200" data-id="element-270">
                  Acceso <strong className="text-white" data-id="element-271">Inmediato</strong> por
                  Email
                </span>
              </div>
              <div className="flex items-start gap-3 bg-cyan-neon/5 border border-cyan-neon/10 rounded-xl px-4 py-3 transition-colors hover:border-cyan-neon/25" data-id="element-272">
                <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-273" />
                <span className="font-inter text-sm text-gray-200" data-id="element-274">
                  Ebook Protocolo de Blindaje{' '}
                  <strong className="text-white" data-id="element-275">Completo</strong> (PDF)
                </span>
              </div>
            </div>

            <div className="mb-5 bg-gradient-to-r from-cyan-neon/10 to-transparent border border-cyan-neon/20 rounded-xl p-5" data-id="element-276">
              <div className="flex items-center gap-2 mb-4" data-id="element-277">
                <span className="text-2xl" data-id="element-278">🎁</span>
                <span className="font-bebas text-xl text-cyan-neon tracking-wider" data-id="element-279">
                  3 BONUS EXCLUSIVOS
                </span>
              </div>

              <div className="space-y-3" data-id="element-280">
                <div className="flex items-start gap-3 bg-deep-black/40 rounded-lg px-4 py-3 border border-cyan-neon/10 transition-colors hover:border-cyan-neon/30" data-id="element-281">
                  <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-282" />
                  <span className="font-inter text-sm text-gray-200" data-id="element-283">
                    <strong className="text-cyan-neon" data-id="element-284">Bonus #1:</strong>{' '}
                    Auxilio 60s
                  </span>
                </div>
                <div className="flex items-start gap-3 bg-deep-black/40 rounded-lg px-4 py-3 border border-cyan-neon/10 transition-colors hover:border-cyan-neon/30" data-id="element-285">
                  <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-286" />
                  <span className="font-inter text-sm text-gray-200" data-id="element-287">
                    <strong className="text-cyan-neon" data-id="element-288">Bonus #2:</strong> Mapa
                    de Disparadores
                  </span>
                </div>
                <div className="flex items-start gap-3 bg-deep-black/40 rounded-lg px-4 py-3 border border-cyan-neon/10 transition-colors hover:border-cyan-neon/30" data-id="element-289">
                  <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-290" />
                  <span className="font-inter text-sm text-gray-200" data-id="element-291">
                    <strong className="text-cyan-neon" data-id="element-292">Bonus #3:</strong>{' '}
                    Restauración V10
                  </span>
                </div>
              </div>
            </div>

            <a href="https://pay.hotmart.com/C105102234Y?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={handleEsencialClick} className="w-full py-5 bg-cyan-neon/10 border-2 border-cyan-neon text-cyan-neon font-bebas text-xl tracking-wider rounded-xl hover:bg-cyan-neon hover:text-deep-black transition-all duration-300 block text-center hover:-translate-y-0.5" style={{
            boxShadow: '0 0 20px rgba(0, 242, 255, 0.3)'
          }} data-id="element-293">
              ACTIVAR BLINDAJE ESENCIAL
            </a>
          </div>

          {/* Tier 2: PRO (Highlighted) */}
          <div id="plan-recomendado" className="bg-card-dark border-2 border-cyan-neon rounded-2xl p-8 flex flex-col h-full relative transform lg:-translate-y-4 z-10" style={{
          boxShadow: '0 0 40px rgba(0, 242, 255, 0.25), 0 0 80px rgba(0, 242, 255, 0.08)'
        }} data-id="element-294">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-cyan-neon text-deep-black font-bebas px-6 py-1.5 rounded-full text-sm tracking-widest flex items-center gap-2" style={{
            boxShadow: '0 0 15px rgba(0, 242, 255, 0.5)'
          }} data-id="element-295">
              <Star className="w-4 h-4 fill-deep-black" data-id="element-296" /> RECOMENDADO
            </div>

            <div className="mb-8 mt-4" data-id="element-297">
              <div className="flex items-center gap-3 mb-3" data-id="element-298">
                <span className="text-2xl" data-id="element-299">🎧</span>
                <h3 className="font-bebas text-cyan-neon tracking-wide text-[32px] leading-none" data-id="element-300">
                  PROTOCOLO AUDIBLE
                </h3>
              </div>
              <h4 className="font-bebas text-white/80 tracking-wide mb-4 text-[22px]" data-id="element-301">
                Tu Guía Secreta{' '}
                <span className="text-cyan-neon" data-id="element-302">(Privacidad 100%)</span>
              </h4>

              <div className="flex items-baseline gap-3" data-id="element-303">
                <span className="font-bebas text-white text-[64px] leading-none" data-id="element-304">
                  $14.99
                </span>
                <span className="text-text-muted font-inter text-sm" data-id="element-305">USD</span>
              </div>
              <div className="flex items-center gap-3 mt-2" data-id="element-306">
                <span className="font-inter text-sm text-text-muted line-through decoration-alert-red decoration-2" data-id="element-307">
                  $97 USD
                </span>
                <span className="bg-alert-red/20 text-alert-red font-inter text-xs font-bold px-3 py-1 rounded-full border border-alert-red/30 uppercase tracking-wider" data-id="element-308">
                  -85% OFF
                </span>
              </div>

              <p className="text-sm text-gray-300 mt-5 font-inter leading-relaxed" data-id="element-309">
                Todo el sistema esencial + la{' '}
                <strong className="text-white" data-id="element-310">Versión Audio</strong> para
                reprogramar tu mente mientras entrenas o conduces{' '}
                <strong className="text-cyan-neon" data-id="element-311">
                  con privacidad total.
                </strong>
              </p>
            </div>

            <div className="mb-8 rounded-xl overflow-hidden border border-cyan-neon/20" data-id="element-312">
              <img src="https://cdn.magicpatterns.com/uploads/nBs5CfGyEfCHEQnaTgNp6z/TODOS_MAS_EL_AUDIOLIBRO.png" alt="Protocolo de Blindaje con Audiolibro y Bonus" className="w-full h-auto" data-id="element-313" />
            </div>

            <div className="space-y-3 mb-8 flex-1" data-id="element-314">
              <div className="flex items-start gap-3 bg-cyan-neon/5 border border-cyan-neon/15 rounded-xl px-4 py-3 transition-colors hover:border-cyan-neon/30" data-id="element-315">
                <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-316" />
                <span className="font-inter text-sm text-gray-200" data-id="element-317">
                  <strong className="text-white" data-id="element-318">
                    Todo lo del plan Esencial
                  </strong>{' '}
                  incluido
                </span>
              </div>
              <div className="flex items-start gap-3 bg-cyan-neon/5 border border-cyan-neon/15 rounded-xl px-4 py-3 transition-colors hover:border-cyan-neon/30" data-id="element-319">
                <Check className="w-5 h-5 text-cyan-neon shrink-0 mt-0.5" data-id="element-320" />
                <span className="font-inter text-sm text-gray-200" data-id="element-321">
                  Audiolibro Completo{' '}
                  <strong className="text-cyan-neon" data-id="element-322">(Privacidad Total)</strong>
                </span>
              </div>
            </div>

            <a href="https://pay.hotmart.com/N105102509N?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={handleAudioClick} className="btn-3d-glow w-full py-5 text-xl block text-center" style={{
            boxShadow: '0 0 25px rgba(0, 242, 255, 0.5), inset 0 -3px 0 rgba(0, 0, 0, 0.2)'
          }} data-id="element-323">
              SÍ, QUIERO EL AUDIO
            </a>
          </div>

          {/* Tier 3: Soberanía Total */}
          <div className="bg-card-dark border border-cyan-neon rounded-2xl p-8 flex flex-col h-full relative glow-cyan" data-id="element-324">
            <div className="mb-8" data-id="element-325">
              <h3 className="font-bebas tracking-wide mb-2 text-[#00F2FF] text-[32px]" data-id="element-326">
                SOBERANÍA TOTAL
              </h3>
              <div className="flex items-baseline gap-2" data-id="element-327">
                <span className="font-bebas text-5xl text-white" data-id="element-328">$19.99</span>
                <span className="text-text-muted font-inter text-sm" data-id="element-329">USD</span>
              </div>
              <p className="text-sm text-text-muted mt-4 font-inter" data-id="element-330">
                El arsenal definitivo. Hackea tu subconsciente mientras duermes.
              </p>
            </div>

            <div className="mb-8" data-id="element-331">
              <img src="https://cdn.magicpatterns.com/uploads/xymyWXftnSbKSg84VB31vB/TODOS_MAS_LA_REPORGRAMACION.png" alt="Bundle Completo 5 Piezas - Soberanía Total" className="w-full h-auto rounded-lg" data-id="element-332" />
            </div>

            <ul className="space-y-4 mb-8 flex-1 font-inter text-sm text-text-muted" data-id="element-333">
              <li className="flex items-start gap-3" data-id="element-334">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-335" />
                <span data-id="element-336">
                  <strong className="text-white" data-id="element-337">Todo lo del plan PRO</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-338">
                <Zap className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-339" />
                <span className="text-white" data-id="element-340">
                  Audio Reprogramación Medianoche (Theta 6Hz)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-341">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-342" />
                <span data-id="element-343">Acelera recuperación al 300%</span>
              </li>
            </ul>

            <a href="https://pay.hotmart.com/N105102600E?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={handleSoberaniaClick} className="w-full py-4 border border-cyan-neon text-cyan-neon font-bebas text-xl tracking-wider rounded-lg hover:bg-cyan-neon hover:text-deep-black transition-colors duration-300 block text-center" data-id="element-344">
              QUIERO SOBERANÍA TOTAL
            </a>
          </div>
        </div>
      </div>
    </section>;
}